export default __webpack_public_path__ + "static/media/spaces_openapi.98fc6baa.yaml";